export default __webpack_public_path__ + "static/media/0.2efb1f62.mp4";